import React, { FunctionComponent, useState } from 'react';

import { HomeFullPageProps } from 'scenes/home/types';
import { SingleYesNoStep } from 'scenes/common/components/Steps';
import { InsuredItem } from 'scenes/common/types';
import { getSpecifiedContentsAnswer } from 'scenes/home/selectors';

import SpecifiedContentsModal from './SpecifiedContentsModal';
import InformationTable from './InformationTable';

export const QUESTION =
  'Do you wish to cover specified items above the policy limits?';
const STATE_KEY = 'specifiedContentsAnswer';

const HELP_TEXT = (
  <div style={{ marginBottom: '20px' }} data-testid="contents-help-text">
    Cover in the {InsuredItem.Home} for specified contents is at no extra cost.
    Items with a value greater than the limits shown below need to be listed in
    order to be covered for their full value. <br />
    Portable contents is an optional extra that covers you in the{' '}
    {InsuredItem.Home} and Australia-wide.
  </div>
);

const SpecifiedContentsAnswerStep: FunctionComponent<Pick<
  HomeFullPageProps,
  'funnelState' | 'onNext' | 'onClickSaveQuoteModal'
>> = ({ funnelState, onNext, onClickSaveQuoteModal }) => {
  const [showModal, setShowModal] = useState(false);

  return (
    <>
      <SingleYesNoStep
        question={QUESTION}
        stateKey={STATE_KEY}
        defaultStateValue={getSpecifiedContentsAnswer(funnelState)}
        onNext={onNext}
        helpText={HELP_TEXT}
        helpLink={{
          id: 'helpModal',
          text:
            'You can specify items at the home at no extra cost. Find out more.',
          ariaLabel:
            'You can specify items at the home at no extra cost. Find out more. Opens dialog',
          onClick: () => {
            setShowModal(true);
          },
        }}
        onClickSaveQuoteModal={onClickSaveQuoteModal}
      />
      <InformationTable />
      <SpecifiedContentsModal
        isOpen={showModal}
        onClose={() => setShowModal(false)}
      />
    </>
  );
};

export default SpecifiedContentsAnswerStep;
